import React, { useEffect, useState } from 'react'
import Service from '../../Services/service'
import { Link } from 'react-router-dom';
import { UserListHooks } from '../../Helper/UsersHelper';
import { hasCreatePermission, hasdeletePermission, hasEditPermission, hasSharePermission } from "../../Utils/PermissionUtils";
import ShareModal from '../../Utils/ShareModal';
import service from '../../Services/service';
import DeleteModal from '../../Utils/DeleteModal';
import { toast } from 'react-toastify';

function UserListComponent() {
    const [lists, setLists] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('Name');
    const [sortDescending, setSortDescending] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalitems, setTotalitems] = useState(0);

    const [showModal, setShowModal] = useState(false);
    const [selectedScreenName, setSelectedScreenName] = useState('');
    const [selectedrowId, setSelectedRowId] = useState(0);

    const canEditUser = hasEditPermission('User');
    const canDeleteUser = hasdeletePermission('User');
    const canShareUser = hasSharePermission('User');

    const [deleteId, setDeleteId] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    async function getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize) {

        const data = await UserListHooks(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
        if (data) {
            setLists(data.items);
            setTotalPages(data.totalPages);
            setTotalitems(data.totalItems);
        }
    }

    const handleSortChange = (event) => {
        const [field, order] = event.target.value.split('_');
        setSortBy(field);
        setSortDescending(order === 'desc');
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPageNumber(newPage);
        }
    };

    const handleDeleteClick = (id, name) => {
        setSelectedScreenName(name);
        setDeleteId(id);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = async () => {
        try {
            const response = await service.getdata("User/DeleteById?id=" + deleteId);
            if (response !== undefined) {
                toast.success('User Deleted successfully!');
                // Replace below with your actual refresh logic
                getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
            }
        } catch (error) {
            toast.error('Error deleting User. Please try again.');
        } finally {
            setShowDeleteModal(false);
        }
    };


    useEffect(() => {
        getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
    }, [searchTerm, sortBy, sortDescending, pageNumber, pageSize]);


    return (
        <div>
            <div class="container-fluid content-top-gap">
                <nav aria-label="breadcrumb" class="mb-4">
                    <ol class="breadcrumb my-breadcrumb">
                        <li class="breadcrumb-item"><a href="/">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">User List</li>
                    </ol>
                </nav>

                <div >
                    <div class="row">

                        <div class="col-lg-12 mb-4">
                            <div class="card card_border mb-4">
                                <div className="card-header">
                                    <div className="d-flex justify-content-between align-items-center">

                                        <div>
                                            <h3 className="mb-1 font-weight-bold">
                                                User Management
                                            </h3>

                                            <small className="text-muted">
                                                Create and manage user's
                                            </small>
                                        </div>

                                        {hasCreatePermission('User') && (
                                            <Link
                                                to="/CreateUser"
                                                className="btn btn-outline-primary btn-sm"
                                            >
                                                <i className="fa fa-plus mr-2"></i>
                                                New User
                                            </Link>
                                        )}

                                    </div>
                                </div>
                                <div class="card-body">

                                    <div className='row mb-3'>
                                        <div className='col-md-4 '>
                                            <input type="text" className='form-control' placeholder="Search by name..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                                        </div>
                                        <div className="col-md-4 mt-2 mt-md-0">
                                            <select
                                                className="custom-select"
                                                onChange={handleSortChange}
                                                value={`${sortBy}_${sortDescending ? 'desc' : 'asc'}`}
                                            >
                                                <option value="Name_asc">Name (A-Z)</option>
                                                <option value="Name_desc">Name (Z-A)</option>
                                                <option value="CreatedAt_asc">Created At (Oldest)</option>
                                                <option value="CreatedAt_desc">Created At (Newest)</option>
                                                <option value="UpdatedAt_asc">Updated At (Oldest)</option>
                                                <option value="UpdatedAt_desc">Updated At (Newest)</option>
                                                <option value="CreatedBy_asc">Created By (A-Z)</option>
                                                <option value="CreatedBy_desc">Created By (Z-A)</option>
                                            </select>
                                        </div>
                                        <div className="col-md-4 mt-2 mt-md-0">
                                            <select
                                                className="custom-select"
                                                value={pageSize}
                                                onChange={(e) => {
                                                    setPageSize(Number(e.target.value));
                                                    setPageNumber(1); // reset to page 1
                                                }}
                                            >
                                                <option value={10}>Show 10</option>
                                                <option value={20}>Show 20</option>
                                                <option value={50}>Show 50</option>
                                                <option value={100}>Show 100</option>
                                            </select>
                                        </div>
                                    </div>
                                    <table className="table table-striped table-bordered table-hover" style={{ fontSize: '14px' }}>
                                        <thead className="bg-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Email</th>
                                                <th>Full Name</th>
                                                <th>User Name</th>
                                                <th>Role</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {lists.map((list, index) => (

                                                <tr key={list.userId}>
                                                    <td>{index + 1}</td>
                                                    <td>{list.email}</td>
                                                    <td>{list.firstName}  {list.lastName}</td>
                                                    <td>{list.username}</td>
                                                    <td>{list.roleName}</td>
                                                    <td>
                                                        <div className="btn-group" role="group">
                                                            {canEditUser && (
                                                                <>
                                                                    <Link to={`/EditUser/${list.userId}`} className=" btn-sm btn btn-outline-info" title="Edit Layout">
                                                                        Edit
                                                                    </Link>

                                                                </>
                                                            )}

                                                            {canDeleteUser && (
                                                                <Link to="#" className="btn btn-outline-danger btn-sm" title="Delete User" onClick={() => handleDeleteClick(list.userId, list.firstName + " " + list.lastName)}>
                                                                    Delete
                                                                </Link>
                                                            )}
                                                            {/* {
                                                                canShareUser && (
                                                                    <Link
                                                                        className="btn btn-outline-success btn-sm"
                                                                        title="Share"
                                                                        onClick={() => {
                                                                            setSelectedScreenName(list.firstName + " " + list.lastName);
                                                                            setShowModal(true);
                                                                            setSelectedRowId(list.userId);
                                                                        }}
                                                                    >
                                                                        Share
                                                                    </Link>
                                                                )
                                                            } */}
                                                        </div>
                                                    </td>

                                                </tr>

                                            ))}
                                        </tbody>
                                    </table>

                                    <div className="d-flex justify-content-between align-items-center flex-wrap mt-4">

                                        <div className="text-muted">
                                            Showing{" "}
                                            <strong>
                                                {(pageNumber - 1) * pageSize + 1}
                                            </strong>
                                            {" - "}
                                            <strong>
                                                {Math.min(pageNumber * pageSize, totalitems)}
                                            </strong>
                                            {" of "}
                                            <strong>{totalitems}</strong>
                                            {" Users"}
                                        </div>

                                        <nav>
                                            <ul className="pagination pagination-sm mb-0">

                                                <li className={`page-item ${pageNumber === 1 ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => setPageNumber(pageNumber - 1)}
                                                    >
                                                        <i className="fa fa-angle-left"></i>
                                                    </button>
                                                </li>

                                                {Array.from({ length: totalPages }, (_, i) => (
                                                    <li
                                                        key={i}
                                                        className={`page-item ${pageNumber === i + 1 ? "active" : ""
                                                            }`}
                                                    >
                                                        <button
                                                            className="page-link"
                                                            onClick={() => setPageNumber(i + 1)}
                                                        >
                                                            {i + 1}
                                                        </button>
                                                    </li>
                                                ))}

                                                <li className={`page-item ${pageNumber === totalPages ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => setPageNumber(pageNumber + 1)}
                                                    >
                                                        <i className="fa fa-angle-right"></i>
                                                    </button>
                                                </li>

                                            </ul>
                                        </nav>

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <ShareModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                screenName={selectedScreenName}
                moduleId={3}
                rowId={selectedrowId}
            />
            <DeleteModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleConfirmDelete}
                message="Are you sure you want to delete this User?"
                itemName={selectedScreenName + " User"}
            />

        </div>
    );
};

export default UserListComponent;
